import { type ICountry } from '@mahawi/eshop-common/src/types';
import React, { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';

import {
  type IOperatorFormValues,
  toOperatorInput,
} from '../components/product-safety/operator-form';
import OperatorsPage from '../components/product-safety/operators-page';
import { useAppDispatch } from '../hooks/use-app-dispatch';
import { type RootState } from '../reducers';
import {
  manufacturerSave,
  manufacturersLoadAll,
} from '../reducers/product-safety/reducer';

function ManufacturersContainer(): React.ReactElement {
  const dispatch = useAppDispatch();
  const manufacturers = useSelector(
    (s: RootState) => s.ProductSafety.manufacturers,
  );
  const inProcess = useSelector((s: RootState) => s.ProductSafety.inProcess);
  const validationErrors = useSelector(
    (s: RootState) => s.ProductSafety.validationErrors,
  );

  useEffect((): void => {
    dispatch(manufacturersLoadAll());
  }, [dispatch]);

  const onReload = useCallback((): void => {
    dispatch(manufacturersLoadAll());
  }, [dispatch]);

  const onSave = useCallback(
    (values: IOperatorFormValues, countryType: ICountry): void => {
      dispatch(manufacturerSave(toOperatorInput(values, countryType)));
    },
    [dispatch],
  );

  return (
    <OperatorsPage
      title="Manufacturers"
      operators={manufacturers}
      withRole={false}
      inProcess={inProcess}
      validationErrors={validationErrors}
      onReload={onReload}
      onSave={onSave}
    />
  );
}

export default ManufacturersContainer;
